import { axiosClient } from "services/axios";

import { StoreItem } from "../../../types";

import { GetStoresParams } from "../types";

export function getStores({ page = 1, pageSize = 1000 }: GetStoresParams = {}) {
  return axiosClient
    .get("stores/", {
      params: {
        page,
        pageSize,
      },
    })
    .then((res) => res.data as StoreItem[])
    .catch((e) => console.warn(e?.message, "while getting stores"));
}

export function deleteStore(storesid: string) {
  return axiosClient.delete("stores/", {
    params: { storesid },
  });
}
